import React from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { FormProvider, RHFTextField } from '@/shared/components/HookForm'
import { Button } from '@/shared/components/ui/button'
import {
	Modal,
	ModalBody,
	ModalClose,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '@/shared/components/ui/modal'

const FormDataSchema = z.object({
	name: z.string().min(2).max(500),
})
type FormData = z.infer<typeof FormDataSchema>

export function GenericRenameModal({
	isOpen,
	close,
	value,
	title,
	onChange,
}: {
	isOpen: boolean
	value?: string
	onChange: (value: string) => void
	close: () => void
	title: string
}) {
	const { t } = useTranslation()

	const onSubmit = (data: FormData) => {
		onChange(data.name)
		close()
	}
	const methods = useForm<FormData>({
		resolver: zodResolver(FormDataSchema),
		defaultValues: {
			name: value,
		},
	})

	return (
		<Modal open={isOpen} onOpenChange={(open) => !open && close()}>
			<ModalContent>
				<FormProvider
					onSubmit={methods.handleSubmit(onSubmit)}
					methods={methods}
					className='grid gap-4'
				>
					<ModalHeader>
						<ModalTitle>{title}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<RHFTextField
							className='w-full'
							label={t('general_name')}
							placeholder={t('general_name')}
							name='name'
						/>
					</ModalBody>
					<ModalFooter>
						<ModalClose asChild>
							<Button>{t('general_cancel')}</Button>
						</ModalClose>
						<Button
							variant='primary'
							onClick={methods.handleSubmit(onSubmit)}
							disabled={!methods.formState.isDirty}
						>
							{t('general_apply')}
						</Button>
					</ModalFooter>
				</FormProvider>
			</ModalContent>
		</Modal>
	)
}
